import React, { useRef } from 'react';
import Link from 'next/link';
import Modal from '@common/modal';
import Button from '@components/common/button';
import Icon from '@components/common/assets';
import { PositionDetailVO } from '@domain/vo/position/jd/PositionDetailVO';
import { V2RouteUrl } from '@utils/routeUtil';

import DateFormat from '@utils/date/format';
import DateUtil from '@utils/date/util';
import classnames from 'classnames/bind';
import styles from './modals.module.scss';
const cx = classnames.bind(styles);

interface ApplySuccessModal {
  visible: boolean;
  onClose: () => void;
  positionDetail: PositionDetailVO;
}

const ApplySuccessModal = ({ visible, onClose, positionDetail }: ApplySuccessModal) => {
  const applyTime = useRef(DateFormat.format(DateUtil.getNow(), 'yyyy.MM.dd(week) HH:mm'));
  const {
    basicInfo: { positionName, positionSn },
    companyInfo: { companyName },
  } = positionDetail;

  return (
    <Modal visible={visible} onClickBg={onClose}>
      <div className={cx('applySuccessModal')}>
        <Icon name="doneGreenFill" />
        <h2 className={cx('title')}>지원이 완료되었습니다.</h2>

        <article className={cx('description')}>
          <div className={cx('descContent')}>
            <span className={cx('descTitle')}>포지션명 : </span>
            {positionName}
          </div>
          <div className={cx('descContent')}>
            <span className={cx('descTitle')}>기업 : </span>
            {companyName}
          </div>
          <div className={cx('descContent')}>
            <span className={cx('descTitle')}>지원완료일시 : </span>
            {applyTime.current}
          </div>
          <div className={cx('info')}>
            *제출한 지원서는 <span className={cx('fontDark')}>지원 현황 {`>`} 해당 포지션</span> 클릭시 확인 가능합니다.
          </div>
        </article>

        <Link href={{ pathname: V2RouteUrl.MATCH, query: { sn: positionSn } }}>
          <Button className={cx('button')}>지원 내역 확인하기</Button>
        </Link>

        <a className={cx('btnClose')} role="button" onClick={onClose}>
          <span className={cx('hidden')}>close</span>
        </a>
      </div>
    </Modal>
  );
};

export default ApplySuccessModal;
